export enum FileInput {
  Attachment = 'file-input-attachment',
  Thumbnail = 'file-input-thumbnail',
}